import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import "./assets/styles/main.css"
import { createWatcher }from 'next-vue-storage-watcher';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

export const lsWatcher = createWatcher({
    prefix:"ovdel_"
})


createApp(App).use(store).use(router).use(VueSweetalert2).mount('#app')

import "bootstrap/dist/js/bootstrap.js"
